import React, { useEffect, useState } from "react";
import api from "../../config/api";
import TaskCalendar from "../tasks/TaskCalendar";
import moment from "moment";
import useHeader from "../../hooks/useHeader";
import AppModal from "../../common/AppModal";
import { LookupRange } from "../tasks/LookupRange";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { getTasks } from "../../stores/TaskStore";
import { useQuery } from "@tanstack/react-query";

export default function EmployeeEvents() {
  const { employee } = useParams();
  const [memory, setMemory] = useState();
  const [tasks, setTasks] = useState([]);
  const { setHeader } = useHeader();
  const [model, setModel] = useState({});
  const calendarRef = React.useRef();

  const { data } = useQuery({
    queryFn: () => getTasks({ employee }),
    queryKey: ["tasks"],
  });

  useEffect(() => {
    if (data) {
      const employees = Array.isArray(data[0]?.employee)
        ? data[0]?.employee
        : [data[0]?.employee];
      const emp = employees.find((i) => i?._id === employee);
      setHeader(emp?.name || "N/A");
      setTasks(data);
      setMemory(data);
    }
  }, [data]);

  useEffect(() => {
    filterLoad();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memory]);

  const durations = tasks
    ?.filter((i) => i.status === "Done")
    .map((i) => {
      const startTime = moment(i.startTime, "hh:mma");
      const endTime = moment(i.endTime, "hh:mma");

      var duration = moment.duration(endTime.diff(startTime));
      return `${duration.get("hours")}:${duration.get("minutes")}`;
    });

  const durSum = durations?.reduce(
    (acc, time) => acc.add(moment.duration(time)),
    moment.duration()
  );
  const durHour = Math.floor(durSum?.asHours() || 0);
  const durMin = Math.floor(durSum?.minutes() || 0);

  const filterLoad = () => {
    if (memory) {
      filterRange();
    }
  };
  const filterRange = () => {
    let calendarApi = calendarRef.current.getApi();
    let viewApi = calendarApi.view;
    const start = viewApi.currentStart;
    const end = viewApi.currentEnd;
    const filtered = memory.filter((i) => {
      return (
        new Date(start) < new Date(i.date) && new Date(end) > new Date(i.date)
      );
    });
    setTasks(filtered);
  };
  const Lookup = LookupRange();
  return (
    <div className="d-flex" style={{ flexGrow: 1 }}>
      <div style={{ width: "100%", position: "relative" }}>
        <div style={{ position: "absolute", right: 30, top: 20 }}>
          <h5>Job Done: {`${durHour} h ${durMin} m`} </h5>
        </div>
        <TaskCalendar
          innerRef={calendarRef}
          tasks={memory}
          initialView="listMonth"
          headerToolbar={{
            left: "prev,next,lookup",
            center: "title",
            right: "",
          }}
          customButtons={{
            prev: {
              click: () => {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.prev();
                filterRange();
              },
            },
            next: {
              click: () => {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.next();
                filterRange();
              },
            },
            lookup: {
              text: "Lookup",
              click: () => {
                setModel({
                  visible: true,
                  body: <Lookup.Body events={memory} />,
                  footer: <Lookup.Footer />,
                  header: <Lookup.Header />,
                });
              },
            },
          }}
        />
      </div>
      <AppModal
        {...model}
        onHide={() => {
          setModel({});
        }}
      />
    </div>
  );
}
